module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-32-15afdd86361c80d988f87fdc65c2bf24.jpg";